module.exports = __webpack_public_path__ + "static/media/page101_02.612672c9.jpg";